import React from 'react';
import Papa from 'papaparse';
import { FaFileCsv } from "react-icons/fa";
import { TiDocumentDelete } from "react-icons/ti";
import './CsvDropzone.css';


const CsvDropzone = ({ onParsed, fileName, onDelete }) => {


  const handleFile = (file) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        onParsed(results.data, file.name);
      }
    });
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file?.type === 'text/csv') handleFile(file);
  };

  return (
    <div
      onDrop={handleDrop}
      onDragOver={(e) => e.preventDefault()}
      style={{
        border: '2px dashed white',
        textAlign: 'center',
        cursor: 'pointer',
        minWidth: 'calc(50% - 0.5rem)',
        width: '100%',
        minHeight: '7rem',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      {fileName ? (
        <>
          {/* File Icon */}
          <div
            className='csv-container-icon'
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            style={{
              height: '7rem',
              width: '20%',
              border: 'dashed red 0.2rem',
              display: 'flex',
              fontWeight: 'bold',
              fontSize: '0.9rem',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative'
            }}
          >
              <TiDocumentDelete className='csv-delete-icon' style={{ position: 'absolute', height:'30%', width: '30%', top: '0.5rem', right: '0' }}/>
              <FaFileCsv style={{ width: '50%', height: '50%', fill: '#057fa2', display:'flex'}}/>
          </div>

          {/* Text */}
          <div style={{ width: '80%'}}>
            <p>Momenteel geüpload:</p>
            <p><strong>{fileName}</strong></p>
          </div>
        </>
      ) : (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <p>
            Sleep je CSV-bestand hier of klik om te uploaden.
          </p>
          <input
            type="file"
            accept=".csv"
            onChange={(e) => handleFile(e.target.files[0])}
            style={{ display: 'block', margin: '10px' }}
          />
        </div>
      )}
    </div>
  );
};

export default CsvDropzone;